import httpCustomer from "./httpServiceCustomer";

const apiEndpoint = "/atletas";

export function getStatus() {
  return httpCustomer.get(apiEndpoint + "/ativo");
}
